module.exports = __webpack_public_path__ + "img/Money-Coins.85592369.svg";